export default __webpack_public_path__ + "static/media/logo.17ab15d4.png";